export default "__VITE_ASSET__d4dafb22__"